
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.6 12.625c.019 1.954 1.12 3.066 1.906 3.613.418.29.669.803.474 1.274a11.152 11.152 0 01-1.08 2.005c-.833 1.218-1.698 2.432-3.06 2.457-1.34.025-1.77-.794-3.301-.794-1.531 0-2.01.769-3.277.819-1.316.05-2.318-1.318-3.158-2.532-1.718-2.483-3.03-7.016-1.268-10.076.876-1.52 2.44-2.482 4.139-2.507 1.292-.025 2.51.869 3.3.869s2.271-1.075 3.83-.917c.535.022 1.864.186 2.974 1.195.42.384.27 1.036-.136 1.435-.617.607-1.356 1.65-1.342 3.16zm-2.516-7.432c.512-.62.902-1.418 1.022-2.262a.68.68 0 00-.896-.756c-.758.25-1.52.741-2.032 1.34-.496.574-.944 1.41-1.058 2.287-.061.468.34.849.802.75.841-.182 1.63-.716 2.162-1.359z"}})])
          )
        }
      }
    